export default __webpack_public_path__ + "static/media/Arm-straps of the Blood God (nm).97986039.jpg";